import { datadogRum } from '@datadog/browser-rum';

// Global deduplication cache to prevent tracking the same experiment evaluation multiple times
// This cache is shared across initialization and runtime tracking
const trackedExperiments = new Map<string, string>();

/**
 * Track a feature flag evaluation in Datadog with deduplication.
 * This ensures each experiment:bucket combination is only tracked once per session.
 *
 * @param name - The experiment name
 * @param bucket - The assigned bucket (e.g., "control", "treatment")
 */
export const trackFeatureFlag = (name: string, bucket: string | null) => {
  if (!bucket || !name) return;

  // Check if we've already tracked this experiment with the same bucket
  if (trackedExperiments.get(name) === bucket) return;

  // Track in Datadog and update cache
  datadogRum.addFeatureFlagEvaluation(name, bucket);
  trackedExperiments.set(name, bucket);
};
